<template>
    <div class="container_view">
        <v-card class="content_card" elevation="10" variant="flat">
            <div>
                <header>
                    <v-card-title> Reportes </v-card-title>
                    <v-divider class="mx-3"></v-divider>
                </header>
            </div>

            <div class="content_main_report" v-if="!isLoading">
                <div class="container_img">
                    <img src="@/assets/images/reports.svg" alt="">
                </div>
    
                <div class="container_data">
                    <div class="container_form">
                        <form class="mt-3" v-if="!isLoading && !isLoadingReport">
                            <div class="col-flex-12" v-if="isMultiAdmin">
                                <v-select
                                    label="Despacho"
                                    v-model="formGroup.data.filterDespacho"
                                    :rules="formGroup.rules.filterDespacho"
                                    :items="arrFilterDespachos"
                                    variant="outlined"
                                    item-title="nombre"
                                    item-value="id_db"
                                    class="w-100"                                    
                                    @update:model-value="getUsersByDespachoMA"
                                    prepend-icon="mdi-filter"
                                ></v-select>
                            </div>
                            <div class="w-100">
                                <v-select
                                    label="Tipo de Reporte"
                                    v-model="formGroup.data.typeReport"
                                    :rules="formGroup.rules.typeReport"
                                    :items="arrTypeReport"
                                    variant="outlined"
                                    item-title="value"
                                    item-value="key"
                                    class="w-100"
                                    @update:model-value="getClienteDespachos"
                                    prepend-icon="mdi-text-box-search"
                                ></v-select>
                            </div>
                            <div class="override_content_flex w-100" v-if="formGroup.data.typeReport === 'CL'">                                
                                <div class="col-flex-6">
                                    <v-select
                                        label="Filtrar por"
                                        v-model="formGroup.data.filterCL"
                                        :rules="formGroup.rules.filterCL"
                                        :items="arrFilterCL"
                                        variant="outlined"
                                        item-title="value"
                                        item-value="key"
                                        class="w-100"
                                        :disabled="isBlockFilter"
                                        prepend-icon="mdi-filter"
                                    ></v-select>
                                </div>
                                <div class="col-flex-6">
                                    <v-select
                                        label="Tipo de Plan"
                                        v-model="formGroup.data.typeInfoCL"
                                        :rules="formGroup.rules.typeInfoCL"
                                        :items="arrTypeReportCP"
                                        variant="outlined"
                                        item-title="value"
                                        item-value="key"
                                        class="w-100"
                                        prepend-icon="mdi-notebook-outline"
                                        ></v-select>
                                    </div>
                                    <div class="col-flex-6">
                                        <v-text-field  
                                        label="Fecha Inicio" 
                                        v-model="formGroup.data.dateStartCL"
                                        :rules="formGroup.rules.dateStartCL"
                                        variant="outlined"
                                        @click="openDialogDate('CL', 'FIRST')"
                                        class="w-100"
                                        readonly
                                        prepend-icon="mdi-calendar-month"
                                        ></v-text-field>
                                    </div>
                                    <div class="col-flex-6">
                                        <v-text-field  
                                        label="Fecha Final" 
                                        v-model="formGroup.data.dateEndCL"
                                        :rules="formGroup.rules.dateEndCL"
                                        variant="outlined"
                                        readonly
                                        @click="openDialogDate('CL', 'END')"
                                        class="w-100"
                                        prepend-icon="mdi-calendar-month"
                                    ></v-text-field>
                                </div>
                                <div class="col-flex-12" v-if="formGroup.data.filterCL === 'gestor'">
                                    <v-autocomplete
                                        label="Usuario"
                                        v-model="formGroup.data.filterUserCL"
                                        :rules="formGroup.rules.filterUserCL"
                                        :items="arrUsers"
                                        item-title="NAME_COMPLETE"
                                        item-value="ID"
                                        variant="outlined"
                                        :disabled="isBlockFilter"
                                        prepend-icon="mdi-account-group"
                                    ></v-autocomplete>
                                </div>
    
                            </div>
                            <div class="override_content_flex w-100" v-else-if="formGroup.data.typeReport === 'GE'">                                
                                <div class="col-flex-12">
                                    <v-select
                                        label="Filtrar por"
                                        v-model="formGroup.data.filterGE"
                                        :rules="formGroup.rules.filterGE"
                                        :items="arrFilterGE"
                                        variant="outlined"
                                        item-title="value"
                                        item-value="key"
                                        class="w-100"
                                        :disabled="isBlockFilter"
                                        prepend-icon="mdi-filter"
                                    ></v-select>
                                </div>
                                
                                <div class="col-flex-12" v-if="formGroup.data.filterGE === 'gestor'">
                                    <v-autocomplete
                                        label="Usuario"
                                        v-model="formGroup.data.filterUserGE"
                                        :items="arrUsers"
                                        item-title="NAME_COMPLETE"
                                        item-value="ID"
                                        variant="outlined"
                                        :disabled="isBlockFilter"
                                        prepend-icon="mdi-account-group"
                                    ></v-autocomplete>
                                </div>
    
                                <div class="col-flex-6">
                                    <v-text-field  
                                        label="Fecha Inicio" 
                                        v-model="formGroup.data.dateStartGE"
                                        :rules="formGroup.rules.dateStartGE"
                                        variant="outlined"
                                        readonly
                                        @click="openDialogDate('GE', 'FIRST')"
                                        class="w-100"
                                        prepend-icon="mdi-calendar-month"
                                        ></v-text-field>
                                    </div>
                                    <div class="col-flex-6">
                                        <v-text-field  
                                        label="Fecha Final" 
                                        readonly
                                        v-model="formGroup.data.dateEndGE"
                                        :rules="formGroup.rules.dateEndGE"
                                        variant="outlined"
                                        @click="openDialogDate('GE', 'END')"
                                        class="w-100"
                                        prepend-icon="mdi-calendar-month"
                                    ></v-text-field>
                                </div>
                            </div>
                            <div class="override_content_flex w-100" v-else-if="formGroup.data.typeReport === 'BA'">
                                <div class="col-flex-12" v-if="isMultiAdmin || isAdmin">
                                    <v-autocomplete
                                        label="Despacho Cliente"
                                        v-model="formGroup.data.filterDespachoClienteBA"
                                        :rules="formGroup.rules.filterDespachoClienteBA"
                                        :items="arrFilterDespachoClientes"
                                        variant="outlined"
                                        item-title="nombre"
                                        item-value="id"
                                        class="w-100"
                                        prepend-icon="mdi-filter"
                                    ></v-autocomplete>
                                </div>
                                <div class="col-flex-12">
                                    <v-text-field  
                                        label="Fecha de Reporte" 
                                        readonly
                                        v-model="formGroup.data.dateReportBA"
                                        :rules="formGroup.rules.dateReportBA"
                                        variant="outlined"
                                        @click="openDialogDate('BA', 'REPORT')"
                                        class="w-100"
                                        prepend-icon="mdi-calendar-month"
                                    ></v-text-field>
                                </div>                                
                            </div>
                            <div class="override_content_flex w-100" v-else-if="formGroup.data.typeReport === 'PA'">                                
                                <div class="col-flex-4">
                                    <v-select
                                        label="Filtrar por"
                                        v-model="formGroup.data.filterPA"
                                        :rules="formGroup.rules.filterPA"
                                        :items="arrFilterPA"
                                        variant="outlined"
                                        item-title="value"
                                        item-value="key"
                                        class="w-100"
                                        :disabled="isBlockFilter"
                                        prepend-icon="mdi-filter"
                                        ></v-select>
                                    </div>                                                                        

                                    <div class="col-flex-4">
                                        <v-select
                                        label="Tipo de Pago"
                                        v-model="formGroup.data.typePaymentPA"
                                        :rules="formGroup.rules.typePaymentPA"
                                        :items="arrTypePayment"
                                        variant="outlined"
                                        item-title="value"
                                        item-value="key"
                                        class="w-100"
                                        prepend-icon="mdi-account-credit-card"
                                        ></v-select>
                                    </div>
                                    
                                    <div class="col-flex-4">
                                        <v-select
                                        label="Plan de Pago"
                                        v-model="formGroup.data.filterTypeReport"
                                        :rules="formGroup.rules.filterTypeReport"
                                        :items="arrFilterReportPA"
                                        variant="outlined"
                                        item-title="value"
                                        item-value="key"
                                        class="w-100"
                                        prepend-icon="mdi-notebook-outline"
                                    ></v-select>
                                </div>
    
                                <div class="col-flex-12" v-if="formGroup.data.filterPA === 'gestor'">
                                    <v-autocomplete
                                        label="Usuario"
                                        v-model="formGroup.data.filterUserPA"
                                        :items="arrUsers"
                                        item-title="NAME_COMPLETE"
                                        item-value="ID"
                                        :disabled="isBlockFilter"
                                        prepend-icon="mdi-account-group"
                                        variant="outlined"
                                    ></v-autocomplete>
                                </div>
    
                                <div class="col-flex-6">
                                    <v-text-field  
                                        label="Fecha Inicio" 
                                        readonly
                                        v-model="formGroup.data.dateStartPA"
                                        :rules="formGroup.rules.dateStartPA"
                                        variant="outlined"
                                        @click="openDialogDate('PA', 'FIRST')"
                                        class="w-100"
                                        prepend-icon="mdi-calendar-month"
                                    ></v-text-field>
                                </div>
                                <div class="col-flex-6">
                                    <v-text-field  
                                        label="Fecha Final" 
                                        readonly
                                        v-model="formGroup.data.dateEndPA"
                                        :rules="formGroup.rules.dateEndPA"
                                        variant="outlined"
                                        @click="openDialogDate('PA', 'END')"
                                        class="w-100"
                                        prepend-icon="mdi-calendar-month"
                                    ></v-text-field>
                                </div>
    
                            </div>
                            <div class="override_content_flex w-100" v-else-if="formGroup.data.typeReport === 'DI'">                                
                                <div class="col-flex-12">
                                    <v-select
                                        label="Filtrar por"
                                        v-model="formGroup.data.filterDI"
                                        :rules="formGroup.rules.filterDI"
                                        :items="arrFilterDI"
                                        variant="outlined"
                                        item-title="value"
                                        item-value="key"
                                        class="w-100"
                                        :disabled="isBlockFilter"
                                        prepend-icon="mdi-filter"
                                    ></v-select>
                                </div>                                
    
                                <div class="col-flex-6">
                                    <v-text-field  
                                        label="Fecha Inicio" 
                                        readonly
                                        v-model="formGroup.data.dateStartDI"
                                        :rules="formGroup.rules.dateStartDI"
                                        variant="outlined"
                                        @click="openDialogDate('DI', 'FIRST')"
                                        class="w-100"
                                        prepend-icon="mdi-calendar-month"
                                    ></v-text-field>
                                </div>
                                <div class="col-flex-6">
                                    <v-text-field  
                                        label="Fecha Final" 
                                        readonly
                                        v-model="formGroup.data.dateEndDI"
                                        :rules="formGroup.rules.dateEndDI"
                                        variant="outlined"
                                        @click="openDialogDate('DI', 'END')"
                                        class="w-100"
                                        prepend-icon="mdi-calendar-month"
                                    ></v-text-field>
                                </div>
    
                            </div>
                            <div class="override_content_flex w-100" v-else-if="formGroup.data.typeReport === 'RT'">                                
                                <div class="col-flex-6">
                                    <v-text-field  
                                        label="Fecha Inicio" 
                                        readonly
                                        v-model="formGroup.data.dateStartRT"
                                        :rules="formGroup.rules.dateStartRT"
                                        variant="outlined"
                                        @click="openDialogDate('RT', 'FIRST')"
                                        class="w-100"
                                        prepend-icon="mdi-calendar-month"
                                    ></v-text-field>
                                </div>
                                <div class="col-flex-6">
                                    <v-text-field  
                                        label="Fecha Final" 
                                        readonly
                                        v-model="formGroup.data.dateEndRT"
                                        :rules="formGroup.rules.dateEndRT"
                                        variant="outlined"
                                        @click="openDialogDate('RT', 'END')"
                                        class="w-100"
                                        prepend-icon="mdi-calendar-month"
                                    ></v-text-field>
                                </div>
                            </div>
                            <div v-else>
                                <i>
                                    Seleccione un tipo de reporte para desplegar el formulario
                                </i>
                            </div>
                            <div class="actions_buttons">
                                <v-btn
                                    variant="flat"
                                    class="text-none elevation-0"
                                    color="indigo-darken-3"
                                    prepend-icon="mdi-file-document"
                                    :disabled="!validateForm()"
                                    @click="dialogAlert = true"
                                    text="Generar reporte"
                                ></v-btn>
                            </div>
                        </form>
                        
                        <div class="content_load" v-if="isLoadingReport">
                            <v-progress-circular
                                :size="100"
                                :width="7"
                                color="indigo-darken-3"
                                indeterminate
                            ></v-progress-circular>
                            <i>Espere un momento</i>
                            <div>Generando reporte</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content_load" v-if="isLoading">
                <v-progress-circular
                    :size="100"
                    :width="7"
                    color="indigo-darken-3"
                    indeterminate
                ></v-progress-circular>
                <i>Espere un momento</i>
                <div>Cargando formulario</div>
            </div>
        </v-card>

        <template>
            <v-dialog activator="parent" width="400px" v-model="dialogDate">
                <v-card>
                    <v-card-title>
                        <span class="text-h5">{{ infoDateDialog.title }}</span>
                    </v-card-title>
                    <v-divider class="mx-3"></v-divider>
                    <v-card-text class="px-4 item_calendar">
                        <v-date-picker 
                            v-model="infoDateDialog.date"
                            :hide-header="true"
                            :min="infoDateDialog.minDate"
                            :max="infoDateDialog.maxDate"
                            show-adjacent-months
                            v-on:update:model-value="onDateSelected"
                        ></v-date-picker>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </template>

        <template>
            <v-dialog v-model="dialogAlert" width="350px" persistent>
                <v-card>
                    
                    <v-card-title>
                        <span class="text-h5">Confirmación</span>
                    </v-card-title>
                    <div v-if="!isLoadingReport">
                        <div class="text-center">
                            <img class="img_alert" src="@/assets/images/warning.png">
                        </div>
                        <div class="description-text">
                            <p v-if="formGroup.data.typeReport === 'CL'">
                                ¿Está seguro de generar el reporte de Convenio y Liquidación?
                            </p>
                            <p v-else-if="formGroup.data.typeReport === 'GE'">
                                ¿Está seguro de generar el reporte de Gestión?
                            </p>
                            <p v-else-if="formGroup.data.typeReport === 'BA'">
                                ¿Está seguro de generar el reporte de Batch?
                            </p>
                            <p v-else-if="formGroup.data.typeReport === 'PA'">
                                ¿Está seguro de generar el reporte de Pagos?
                            </p>
                            <p v-else-if="formGroup.data.typeReport === 'DI'">
                                ¿Está seguro de generar el reporte de Domicilios?
                            </p>
                            <p v-else-if="formGroup.data.typeReport === 'RT'">
                                ¿Está seguro de generar el reporte de Teléfonos?
                            </p>
                            <p v-else>Opción no disponible</p>
                        </div>
                    </div>
                    <div class="content_load" v-if="isLoadingReport">
                        <v-progress-circular
                            :size="100"
                            :width="7"
                            color="indigo-darken-3"
                            indeterminate
                        ></v-progress-circular>
                        <i>Espere un momento</i>
                        <div>Generando reporte</div>
                    </div>
                    <v-card-actions class="actions_buttons">
                        <v-btn 
                            variant="flat"
                            class="text-none"
                            color="red"
                            :disabled="isLoadingReport"
                            @click="dialogAlert = false"
                            text="Cerrar"
                        ></v-btn>
                        <v-btn 
                            variant="flat"
                            class="text-none"
                            color="indigo-darken-3"
                            :disabled="isLoadingReport"
                            @click="generateReport()"
                            text="Generar"
                        ></v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>

        <SnackbarComponent :value="snackbarData"/>
    </div>
</template>

<script>
import { EncryptService } from '@/services/EncryptService'
import { UserManagementService } from '@/services/UserManagementService'
import { ReportService } from '@/services/ReportService'
export default {
    name: 'ReportsView',
    props: {
        msg: String,
    },
    data() {
        return {
            isLoading: false,
            isLoadingReport: false,
            dialogDate: false,
            dialogAlert: false,

            infoDateDialog: {
                typeForm: null,
                typeDate: 'FIRST' | 'END',
                title: null,
                date: null,
                minDate: null,
                maxDate: null,
            },
            arrTypeReport: [
            ],
            formGroup: {
                data: {
                    typeReport: null,
                    filterDespacho:null,

                    filterCL: null,
                    dateStartCL: null,
                    dateEndCL: null,
                    typeInfoCL: null,
                    filterUserCL: null,                    

                    filterGE: null,
                    filterUserGE: null,
                    dateStartGE: null,
                    dateEndGE: null,                   

                    dateReportBA: null,
                    filterDespachoClienteBA:null,

                    filterPA: null,
                    typePaymentPA: null,
                    filterUserPA: null,
                    dateStartPA: null,
                    dateEndPA: null,
                    filterTypeReport: null,

                    filterDI: null,
                    dateStartDI: null,
                    dateEndDI: null,

                    dateStartRT: null,
                    dateEndRT: null,
                    
                },
                rules: {
                    typeReport: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Tipo de Reporte es obligatorio`
                            }
                            return true
                        }
                    ],
                    filterDespacho:[
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                 return `El campo Despacho es obligatorio`
                            }
                            return true
                        }
                    ],
                    filterCL: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Filtrar por es obligatorio`
                            }
                            return true
                        }
                    ],
                    dateStartCL: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Fecha Inicio es obligatorio`
                            }
                            return true
                        }
                    ],
                    dateEndCL: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Fecha Final por es obligatorio`
                            }
                            return true
                        }
                    ],
                    typeInfoCL: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Tipo de Plan por es obligatorio`
                            }
                            return true
                        }
                    ],
                    filterUserCL: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Usuario por es obligatorio`
                            }
                            return true
                        }
                    ],

                    filterGE: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Filtrar por es obligatorio`
                            }
                            return true
                        }
                    ],
                    filterUserGE: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Usuario es obligatorio`
                            }
                            return true
                        }
                    ],
                    dateStartGE: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Fecha Inicio es obligatorio`
                            }
                            return true
                        }
                    ],
                    dateEndGE: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Fecha Final por es obligatorio`
                            }
                            return true
                        }
                    ],

                    dateReportBA: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Fecha de Reporte es obligatorio`
                            }
                            return true
                        }
                    ],
                    filterDespachoClienteBA:[
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Despacho Cliente es obligatorio`
                            }
                            return true
                        }
                    ],

                    filterPA: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Filtrar por es obligatorio`
                            }
                            return true
                        }
                    ],
                    typePaymentPA: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Tipo de Pago es obligatorio`
                            }
                            return true
                        }
                    ],
                    filterUserPA: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Usuario es obligatorio`
                            }
                            return true
                        }
                    ],
                    dateStartPA: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Fecha Inicio es obligatorio`
                            }
                            return true
                        }
                    ],
                    dateEndPA: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Fecha Final por es obligatorio`
                            }
                            return true
                        }
                    ],
                    filterTypeReport: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Plan de Pago por es obligatorio`
                            }
                            return true
                        }
                    ],

                    filterDI: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Filtrar por es obligatorio`
                            }
                            return true
                        }
                    ],
                    dateStartDI: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Fecha Inicio es obligatorio`
                            }
                            return true
                        }
                    ],
                    dateEndDI: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Fecha Final por es obligatorio`
                            }
                            return true
                        }
                    ],
                    
                    dateStartRT: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Fecha Inicio es obligatorio`
                            }
                            return true
                        }
                    ],
                    dateEndRT: [
                        value => {
                            if (value === null || value === '' || value === undefined) {
                                return `El campo Fecha Final por es obligatorio`
                            }
                            return true
                        }
                    ],                    
                }
            },
            arrFilterCL: [
                { key: 'gestor', value: 'Gestor' },
                // { key: 'encargado', value: 'Encargado' },
                { key: 'todo', value: 'Todos' },
            ],
            arrFilterGE: [
                { key: 'gestor', value: 'Gestor' },
                { key: 'todo', value: 'Todos' },
            ],
            arrFilterPA: [
                { key: 'gestor', value: 'Gestor' },
                { key: 'todo', value: 'Todos' },
            ],
            arrFilterReportPA: [
                { key: 'nuevo', value: 'Nuevo' },
                { key: 'recurrente', value: 'Recurrente' },
                { key: 'todo', value: 'Todos' },
            ],
            arrFilterDI: [
                { key: 'gestor', value: 'Gestor' },
                { key: 'scl', value: 'SCL' },
                { key: 'todo', value: 'Todos' },
            ],
            arrTypeReportCP: [
                { key: 'convenio', value: 'Convenio' },
                // { key: 'liquidación', value: 'Liquidación' },
                { key: 'intencion', value: 'Pago Intención' },
                { key: 'todo', value: 'Todos' },
            ],
            arrTypePayment: [
                { key: 'pendiente', value: 'Pendiente' },
                { key: 'pagado', value: 'Pagado' },
                { key: 'todo', value: 'Todos' },
            ],
            snackbarData: { openSnackbar: false, description: '' },
            arrUsers: [],
            isBlockFilter: false,

            permission: {
                downloadReportAgreementsAndSettlements: false,
                downloadReportManagement: false,
                downloadReportPayment: false,
                downloadReportDirection: false,
            },
            
            isMultiAdmin:false,
            arrFilterDespachos:[],
            isAdmin: false,
            arrFilterDespachoClientes: [],
        }
    },
    async created() {
        this.isLoading = true
        try {
            await this._getUsersByDispatch()
        } catch (error) {
            this.snackbarData.description = 'No se pudieron cargar los usuarios. Intente de nuevo.'
            this.snackbarData.openSnackbar = true
        } finally {
            this.isLoading = false
        }

        const ENC_TYPE = localStorage.getItem('TIPO')
        const TYPE_USER = await EncryptService.decrypt(ENC_TYPE)   
        
        this.isMultiAdmin = TYPE_USER == 'Multiadmin' ? true : false; 
        this.isAdmin = TYPE_USER == 'Administrador' ? true : false; 

        this.isBlockFilter = TYPE_USER === 'Gestor' || TYPE_USER === 'Colaborador'

        if (this.isBlockFilter) {
            this.formGroup.data.filterCL = 'gestor'
            this.formGroup.data.filterGE = 'gestor'
            this.formGroup.data.filterPA = 'gestor'
            this.formGroup.data.filterDI = 'gestor'

            const ID_USER = localStorage.getItem('ID')
            let encIdUSer = ''
            for (const element of this.arrUsers) {
                if (element.ID_NORMAL.toString() === ID_USER.toString()) {
                    encIdUSer = element.ID
                }
            }
            this.formGroup.data.filterUserCL = encIdUSer
            this.formGroup.data.filterUserGE = encIdUSer
            this.formGroup.data.filterUserPA = encIdUSer

        }

        const ENC_PERMISOS = localStorage.getItem('PERMISOS')
        const STR_PERMISOS = atob(ENC_PERMISOS)
        const ARR_PERMISOS = JSON.parse(STR_PERMISOS)
        const PERMISSION = ARR_PERMISOS.find((permission) => permission.modulo === 'M02REPO')

        if(TYPE_USER === 'Administrador' || TYPE_USER == 'Multiadmin') {
            this.arrTypeReport.push({ key: 'BA', value: 'Batch' })
        }
        
        for (const element of (PERMISSION?.endpoints || [])) {
            
            if (element.nombre === 'M02F01DRCL' && element.permiso === true) {
                this.permission.downloadReportAgreementsAndSettlements = true
                this.arrTypeReport.push({ key: 'CL', value: 'Convenio y liquidación' })
            }
            if (element.nombre === 'M02F02DRGE' && element.permiso === true) {
                this.arrTypeReport.push({ key: 'GE', value: 'Gestión' })
                this.permission.downloadReportManagement = true
            }
            if (element.nombre === 'M02F03DRPA' && element.permiso === true) {
                this.permission.downloadReportPayment = true
                this.arrTypeReport.push({ key: 'PA', value: 'Pagos' })
            }
            if (element.nombre === 'M04F04RPDI' && element.permiso === true) {
                this.permission.downloadReportDirection = true
                this.arrTypeReport.push({ key: 'DI', value: 'Domicilios' })
            }
            if (element.nombre === 'M02F03DRTE' && element.permiso === true) {
                this.arrTypeReport.push({ key: 'RT', value: 'Reporte de Teléfonos' })
            }
        }

        if (this.isMultiAdmin) {
            await this.getDispatchByMultiAdmin()
        }

        if(TYPE_USER !== 'Multiadmin'){
            this.formGroup.data.filterDespacho = localStorage.getItem('DESPACHO');            
        }
    },

    methods: {
        openDialogDate: function (typeForm, typeDate ) {
            switch (typeForm) {
                case 'CL':
                    this.infoDateDialog.typeForm = typeForm
                    this.infoDateDialog.typeDate = typeDate;
                    if (typeDate === 'FIRST') {
                        let dateSelected = this.formGroup.data.dateStartCL
                        if (dateSelected === null || dateSelected === undefined || dateSelected === '') {
                            dateSelected = new Date()
                        } else {
                            const ARR_DATE = dateSelected.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            dateSelected = DATE
                        }
                        this.infoDateDialog.date = dateSelected
                        this.infoDateDialog.title = 'Fecha de Inicio'
                        const STR_DATE = this.formGroup.data.dateEndCL
                        if (STR_DATE !== null && STR_DATE !== '') {
                            const ARR_DATE = STR_DATE.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            this.infoDateDialog.maxDate = DATE;
                            this.infoDateDialog.minDate = null;
                        }
                        this.dialogDate = true
                    } else if (typeDate === 'END') {
                        let dateSelected = this.formGroup.data.dateEndCL
                        if (dateSelected === null || dateSelected === undefined || dateSelected === '') {
                            dateSelected = new Date()
                        } else {
                            const ARR_DATE = dateSelected.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            dateSelected = DATE
                        }
                        this.infoDateDialog.date = dateSelected
                        this.infoDateDialog.title = 'Fecha Final'
                        this.dialogDateEnd = true
                        const STR_DATE = this.formGroup.data.dateStartCL
                        if (STR_DATE !== null && STR_DATE !== '') {
                            const ARR_DATE = STR_DATE.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            this.infoDateDialog.minDate = DATE;
                            this.infoDateDialog.maxDate = null;
                        }
                        this.dialogDate = true
                    } else {
                        this.snackbarData.description = `Opción no disponible 1`
                        this.snackbarData.openSnackbar = true
                    }
                    break;
                case 'GE':
                    this.infoDateDialog.typeForm = typeForm
                    this.infoDateDialog.typeDate = typeDate;
                    if (typeDate === 'FIRST') {
                        let dateSelected = this.formGroup.data.dateStartGE
                        if (dateSelected === null || dateSelected === undefined || dateSelected === '') {
                            dateSelected = new Date()
                        } else {
                            const ARR_DATE = dateSelected.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            dateSelected = DATE
                        }
                        this.infoDateDialog.date = dateSelected
                        this.infoDateDialog.title = 'Fecha de Inicio'
                        const STR_DATE = this.formGroup.data.dateEndGE
                        if (STR_DATE !== null && STR_DATE !== '') {
                            const ARR_DATE = STR_DATE.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            this.infoDateDialog.maxDate = DATE;
                            this.infoDateDialog.minDate = null;
                        }
                        this.dialogDate = true
                    } else if (typeDate === 'END') {
                        let dateSelected = this.formGroup.data.dateEndGE
                        if (dateSelected === null || dateSelected === undefined || dateSelected === '') {
                            dateSelected = new Date()
                        } else {
                            const ARR_DATE = dateSelected.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            dateSelected = DATE
                        }
                        this.infoDateDialog.date = dateSelected
                        this.infoDateDialog.title = 'Fecha Final'
                        this.dialogDateEnd = true
                        const STR_DATE = this.formGroup.data.dateStartGE
                        if (STR_DATE !== null && STR_DATE !== '') {
                            const ARR_DATE = STR_DATE.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            this.infoDateDialog.minDate = DATE;
                            this.infoDateDialog.maxDate = null;
                        }
                        this.dialogDate = true
                    } else {
                        this.snackbarData.description = `Opción no disponible 2`
                        this.snackbarData.openSnackbar = true
                    }
                    break;
                case 'BA':
                    this.infoDateDialog.typeForm = typeForm
                    this.infoDateDialog.typeDate = typeDate;
                    if (typeDate === 'REPORT') {
                        let dateSelected = this.formGroup.data.dateReportBA
                        if (dateSelected === null || dateSelected === undefined || dateSelected === '') {
                            dateSelected = new Date()
                        } else {
                            const ARR_DATE = dateSelected.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            dateSelected = DATE
                        }
                        this.infoDateDialog.date = dateSelected
                        this.infoDateDialog.title = 'Fecha de Reporte'
                        this.dialogDate = true
                    } else {
                        this.snackbarData.description = `Opción no disponible 3`
                        this.snackbarData.openSnackbar = true
                    }
                    break;
                case 'PA':
                    this.infoDateDialog.typeForm = typeForm
                    this.infoDateDialog.typeDate = typeDate;
                    if (typeDate === 'FIRST') {
                        let dateSelected = this.formGroup.data.dateStartPA
                        if (dateSelected === null || dateSelected === undefined || dateSelected === '') {
                            dateSelected = new Date()
                        } else {
                            const ARR_DATE = dateSelected.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            dateSelected = DATE
                        }
                        this.infoDateDialog.date = dateSelected
                        this.infoDateDialog.title = 'Fecha de Inicio'
                        const STR_DATE = this.formGroup.data.dateEndPA
                        if (STR_DATE !== null && STR_DATE !== '') {
                            const ARR_DATE = STR_DATE.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            this.infoDateDialog.maxDate = DATE;
                            this.infoDateDialog.minDate = null;
                        }
                        this.dialogDate = true
                    } else if (typeDate === 'END') {
                        let dateSelected = this.formGroup.data.dateEndPA
                        if (dateSelected === null || dateSelected === undefined || dateSelected === '') {
                            dateSelected = new Date()
                        } else {
                            const ARR_DATE = dateSelected.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            dateSelected = DATE
                        }
                        this.infoDateDialog.date = dateSelected
                        this.infoDateDialog.title = 'Fecha Final'
                        this.dialogDateEnd = true
                        const STR_DATE = this.formGroup.data.dateStartPA
                        if (STR_DATE !== null && STR_DATE !== '') {
                            const ARR_DATE = STR_DATE.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            this.infoDateDialog.minDate = DATE;
                            this.infoDateDialog.maxDate = null;
                        }
                        this.dialogDate = true
                    } else {
                        this.snackbarData.description = `Opción no disponible 4`
                        this.snackbarData.openSnackbar = true
                    }
                    break;
                case 'DI':
                    this.infoDateDialog.typeForm = typeForm
                    this.infoDateDialog.typeDate = typeDate;
                    if (typeDate === 'FIRST') {
                        let dateSelected = this.formGroup.data.dateStartDI
                        if (dateSelected === null || dateSelected === undefined || dateSelected === '') {
                            dateSelected = new Date()
                        } else {
                            const ARR_DATE = dateSelected.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            dateSelected = DATE
                        }
                        this.infoDateDialog.date = dateSelected
                        this.infoDateDialog.title = 'Fecha de Inicio'
                        const STR_DATE = this.formGroup.data.dateEndDI
                        if (STR_DATE !== null && STR_DATE !== '') {
                            const ARR_DATE = STR_DATE.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            this.infoDateDialog.maxDate = DATE;
                            this.infoDateDialog.minDate = null;
                        }
                        this.dialogDate = true
                    } else if (typeDate === 'END') {
                        let dateSelected = this.formGroup.data.dateEndDI
                        if (dateSelected === null || dateSelected === undefined || dateSelected === '') {
                            dateSelected = new Date()
                        } else {
                            const ARR_DATE = dateSelected.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            dateSelected = DATE
                        }
                        this.infoDateDialog.date = dateSelected
                        this.infoDateDialog.title = 'Fecha Final'
                        this.dialogDateEnd = true
                        const STR_DATE = this.formGroup.data.dateStartDI
                        if (STR_DATE !== null && STR_DATE !== '') {
                            const ARR_DATE = STR_DATE.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            this.infoDateDialog.minDate = DATE;
                            this.infoDateDialog.maxDate = null;
                        }
                        this.dialogDate = true
                    } else {
                        this.snackbarData.description = `Opción no disponible 5`
                        this.snackbarData.openSnackbar = true
                    }
                    break;
                case 'RT':
                    this.infoDateDialog.typeForm = typeForm
                    this.infoDateDialog.typeDate = typeDate;
                    if (typeDate === 'FIRST') {
                        let dateSelected = this.formGroup.data.dateStartRT
                        if (dateSelected === null || dateSelected === undefined || dateSelected === '') {
                            dateSelected = new Date()
                        } else {
                            const ARR_DATE = dateSelected.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            dateSelected = DATE
                        }
                        this.infoDateDialog.date = dateSelected
                        this.infoDateDialog.title = 'Fecha de Inicio'
                        const STR_DATE = this.formGroup.data.dateEndRT
                        if (STR_DATE !== null && STR_DATE !== '') {
                            const ARR_DATE = STR_DATE.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            this.infoDateDialog.maxDate = DATE;
                            this.infoDateDialog.minDate = null;
                        }
                        this.dialogDate = true
                    } else if (typeDate === 'END') {
                        let dateSelected = this.formGroup.data.dateEndRT
                        if (dateSelected === null || dateSelected === undefined || dateSelected === '') {
                            dateSelected = new Date()
                        } else {
                            const ARR_DATE = dateSelected.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            dateSelected = DATE
                        }
                        this.infoDateDialog.date = dateSelected
                        this.infoDateDialog.title = 'Fecha Final'
                        this.dialogDateEnd = true
                        const STR_DATE = this.formGroup.data.dateStartRT
                        if (STR_DATE !== null && STR_DATE !== '') {
                            const ARR_DATE = STR_DATE.split('-')
                            const DATE = new Date( parseInt(ARR_DATE[0]), parseInt(ARR_DATE[1]) - 1, parseInt(ARR_DATE[2]) )
                            this.infoDateDialog.minDate = DATE;
                            this.infoDateDialog.maxDate = null;
                        }
                        this.dialogDate = true
                    } else {
                        this.snackbarData.description = `Opción no disponible 5`
                        this.snackbarData.openSnackbar = true
                    }
                    break;
                default:
                    this.snackbarData.description = 'Opción no disponible 6'
                    this.snackbarData.openSnackbar = true
                    break;
            }
        },
        onDateSelected: function (selectedDates) {
            const TYPE_FORM = this.infoDateDialog.typeForm
            const TYPE_DATE = this.infoDateDialog.typeDate

            let year = selectedDates.getFullYear()
            let month = selectedDates.getMonth()
            month = parseInt(month) + 1;
            month = parseInt(month) < 10 ? `0${month}` : `${month}`
            let date = selectedDates.getDate()
            date = parseInt(date) < 10 ? `0${date}` : `${date}`

            const DATE = `${year}-${month}-${date}`

            switch (TYPE_FORM) {
                case 'CL':
                    if (TYPE_DATE === 'FIRST') {
                        this.formGroup.data.dateStartCL = DATE
                        this.dialogDate = false
                    } else if (TYPE_DATE === 'END') {
                        this.formGroup.data.dateEndCL = DATE
                        this.dialogDate = false
                    } else {
                        this.snackbarData.description = `Opción no disponible 7`
                        this.snackbarData.openSnackbar = true
                    }
                    break;
                case 'GE':
                if (TYPE_DATE === 'FIRST') {
                        this.formGroup.data.dateStartGE = DATE
                        this.dialogDate = false
                    } else if (TYPE_DATE === 'END') {
                        this.formGroup.data.dateEndGE = DATE
                        this.dialogDate = false
                    } else {
                        this.snackbarData.description = `Opción no disponible 8`
                        this.snackbarData.openSnackbar = true
                    }
                    break;
                case 'BA':
                    if (TYPE_DATE === 'REPORT') {
                        this.formGroup.data.dateReportBA = DATE
                        this.dialogDate = false
                    }else {
                        this.snackbarData.description = `Opción no disponible 10`
                        this.snackbarData.openSnackbar = true
                    }
                    break;
                case 'PA':
                    if (TYPE_DATE === 'FIRST') {
                        this.formGroup.data.dateStartPA = DATE
                        this.dialogDate = false
                    } else if (TYPE_DATE === 'END') {
                        this.formGroup.data.dateEndPA = DATE
                        this.dialogDate = false
                    } else {
                        this.snackbarData.description = `Opción no disponible 11`
                        this.snackbarData.openSnackbar = true
                    }
                    break;
                case 'DI':
                    if (TYPE_DATE === 'FIRST') {
                        this.formGroup.data.dateStartDI = DATE
                        this.dialogDate = false
                    } else if (TYPE_DATE === 'END') {
                        this.formGroup.data.dateEndDI = DATE
                        this.dialogDate = false
                    } else {
                        this.snackbarData.description = `Opción no disponible 12`
                        this.snackbarData.openSnackbar = true
                    }
                    break;
                case 'RT':
                    if (TYPE_DATE === 'FIRST') {
                        this.formGroup.data.dateStartRT = DATE
                        this.dialogDate = false
                    } else if (TYPE_DATE === 'END') {
                        this.formGroup.data.dateEndRT = DATE
                        this.dialogDate = false
                    } else {
                        this.snackbarData.description = `Opción no disponible 12`
                        this.snackbarData.openSnackbar = true
                    }
                    break;
            
                default:
                    this.snackbarData.description = 'Opción no disponible 13'
                    this.snackbarData.openSnackbar = true
                    break;
            }

            this.infoDateDialog.typeForm = null
            this.infoDateDialog.typeDate = 'FIRST' | 'END'
            this.infoDateDialog.title = null
            this.infoDateDialog.date = null
            this.infoDateDialog.minDate = null
            this.infoDateDialog.maxDate = null
        },
        validateForm: function () {
            const FORM_GROUP = this.formGroup.data
            if (FORM_GROUP.typeReport === null || FORM_GROUP === undefined || FORM_GROUP === '') {
                return false
            }

            if (FORM_GROUP.filterDespacho === null || FORM_GROUP.filterDespacho === undefined || FORM_GROUP.filterDespacho === '') {
                return false
            }

            switch (FORM_GROUP.typeReport) {
                case 'CL':
                    if (FORM_GROUP.filterCL === null || FORM_GROUP.filterCL === undefined || FORM_GROUP.filterCL === '') {
                        return false
                    }
                    if (FORM_GROUP.dateStartCL === null || FORM_GROUP.dateStartCL === undefined || FORM_GROUP.dateStartCL === '') {
                        return false
                    }
                    if (FORM_GROUP.dateEndCL === null || FORM_GROUP.dateEndCL === undefined || FORM_GROUP.dateEndCL === '') {
                        return false
                    }
                    if (FORM_GROUP.typeInfoCL === null || FORM_GROUP.typeInfoCL === undefined || FORM_GROUP.typeInfoCL === '') {
                        return false
                    }                                        
                    if (FORM_GROUP.filterCL === 'gestor' && (FORM_GROUP.filterUserCL === null || FORM_GROUP.filterUserCL === undefined || FORM_GROUP.filterUserCL === '')) {
                        return false
                    }
                    return true
                case 'GE':

                    if (FORM_GROUP.filterGE === null || FORM_GROUP.filterGE === undefined || FORM_GROUP.filterGE === '') {
                        return false
                    }
                    if (FORM_GROUP.filterGE === 'gestor' && (FORM_GROUP.filterUserGE === null || FORM_GROUP.filterUserGE === undefined || FORM_GROUP.filterUserGE === '')) {
                        return false
                    }
                    if (FORM_GROUP.dateStartGE === null || FORM_GROUP.dateStartGE === undefined || FORM_GROUP.dateStartGE === '') {
                        return false
                    }
                    if (FORM_GROUP.dateEndGE === null || FORM_GROUP.dateEndGE === undefined || FORM_GROUP.dateEndGE === '') {
                        return false
                    }                   

                    return true
                case 'BA':
                    if (FORM_GROUP.dateReportBA == null || FORM_GROUP.dateReportBA === undefined || FORM_GROUP.dateReportBA === '') {
                        return false
                    }
                    
                    return true
                case 'PA':

                    if (FORM_GROUP.filterPA == null || FORM_GROUP.filterPA === undefined || FORM_GROUP.filterPA === '') {
                        return false
                    }
                    if (FORM_GROUP.typePaymentPA == null || FORM_GROUP.typePaymentPA === undefined || FORM_GROUP.typePaymentPA === '') {
                        return false
                    }
                    if (FORM_GROUP.filterPA === 'gestor' && (FORM_GROUP.filterUserPA == null || FORM_GROUP.filterUserPA === undefined || FORM_GROUP.filterUserPA === '')) {
                        return false
                    }
                    if (FORM_GROUP.dateStartPA == null || FORM_GROUP.dateStartPA === undefined || FORM_GROUP.dateStartPA === '') {
                        return false
                    }
                    if (FORM_GROUP.dateEndPA == null || FORM_GROUP.dateEndPA === undefined || FORM_GROUP.dateEndPA === '') {
                        return false
                    }
                    
                    return true
                case 'DI':
                    if (FORM_GROUP.filterDI == null || FORM_GROUP.filterDI === undefined || FORM_GROUP.filterDI === '') {
                        return false
                    }
                    if (FORM_GROUP.dateStartDI == null || FORM_GROUP.dateStartDI === undefined || FORM_GROUP.dateStartDI === '') {
                        return false
                    }
                    if (FORM_GROUP.dateEndDI == null || FORM_GROUP.dateEndDI === undefined || FORM_GROUP.dateEndDI === '') {
                        return false
                    }
                    
                    return true
                case 'RT':
                    if (FORM_GROUP.dateStartRT == null || FORM_GROUP.dateStartRT === undefined || FORM_GROUP.dateStartRT === '') {
                        return false
                    }
                    if (FORM_GROUP.dateEndRT == null || FORM_GROUP.dateEndRT === undefined || FORM_GROUP.dateEndRT === '') {
                        return false
                    }
                    
                    return true
                default:
                    this.snackbarData.description = 'Opción no disponible 14'
                    this.snackbarData.openSnackbar = true
                    return false
            }

        },
        _getUsersByDispatch: async function () {            
            await UserManagementService.getUsersByDispatch().then(
                async (responseData) => {
                    if (!responseData.error) {
                        let tempArrUser = []
                        for (const element of responseData.response) {
                            tempArrUser.push({
                                ID: await EncryptService.encrypt(element.id.toString()),
                                ID_NORMAL: element.id,
                                NAME_COMPLETE: `${element.name} ${element.last_name} (${element.username})`
                            })
                        }
                        this.arrUsers = tempArrUser
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )          
        },
        generateReport: async function () {

            if (this.formGroup.data.typeReport === 'CL'){
                await this.reportCovenantLiquidation()
                
            } else if (this.formGroup.data.typeReport === 'GE'){
                await this.reportGeneral()
                
            } else if (this.formGroup.data.typeReport === 'BA'){
                await this.reportBatchSCL()
                
            } else if (this.formGroup.data.typeReport === 'PA'){
                await this.reportPayments()

            } else if (this.formGroup.data.typeReport === 'DI'){
                await this.reportDirections()

            } else if (this.formGroup.data.typeReport === 'RT'){
                await this.reportTelephones()

            } else {
                this.snackbarData.description = `Opción no disponible 15`
                this.snackbarData.openSnackbar = true
            }

            this.dialogAlert = false
        },
        reportCovenantLiquidation: async function () {
            this.isLoadingReport = true;
            
            const REQUEST = {
                filtro_usuario: this.formGroup.data.filterCL,
                fecha_inicio: this.formGroup.data.dateStartCL,
                fecha_fin: this.formGroup.data.dateEndCL,
                tipo_reporte: this.formGroup.data.typeInfoCL,
                id_usuario: this.formGroup.data.filterUserCL,
                despacho: this.formGroup.data.filterDespacho
            }

            await ReportService.reportCovenantLiquidation(REQUEST).then(
                (responseData) => {
                    if (!responseData.error) {
                        
                        const URL_FILE = responseData.response
                        window.open(`${URL_FILE}`, '_blank')
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoadingReport = false
        },
        reportGeneral: async function () {
            this.isLoadingReport = true
            
            const REQUEST = {
                fecha_inicio: this.formGroup.data.dateStartGE,
                fecha_fin: this.formGroup.data.dateEndGE,
                tipo: this.formGroup.data.filterGE,
                id_usuario: this.formGroup.data.filterUserGE,
                despacho: this.formGroup.data.filterDespacho
            }
            await ReportService.reportGeneral(REQUEST).then(
                (responseData) => {
                    if (!responseData.error) {
                        const URL_FILE = responseData.response
                        window.open(`${URL_FILE}`, '_blank')
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoadingReport = false
        },
        reportBatchSCL: async function () {
            this.isLoadingReport = true

            const REQUEST = {
                fecha_reporte: this.formGroup.data.dateReportBA,
                despacho: this.formGroup.data.filterDespacho,
                despacho_tabla: this.formGroup.data.filterDespachoClienteBA
            }

            await ReportService.reportBatchSCL(REQUEST).then(
                (responseData) => {
                    if (!responseData.error) {
                        const URL_FILE = responseData.response
                        window.open(`${URL_FILE}`, '_blank')
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoadingReport = false
        },
        reportPayments: async function () {
            this.isLoadingReport = true            

            const REQUEST = {
                filtro_estado: this.formGroup.data.typePaymentPA,
                fecha_inicio: this.formGroup.data.dateStartPA,
                fecha_fin: this.formGroup.data.dateEndPA,
                filtro_usuario: this.formGroup.data.filterPA,
                id_usuario: this.formGroup.data.filterUserPA,
                tipo_reporte: this.formGroup.data.filterTypeReport,
                despacho: this.formGroup.data.filterDespacho
            }

            await ReportService.reportPayments(REQUEST).then(
                (responseData) => {
                    if (!responseData.error) {
                        const URL_FILE = responseData.response
                        window.open(`${URL_FILE}`, '_blank')
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoadingReport = false
        },
        reportDirections: async function () {
            this.isLoadingReport = true
            
            const REQUEST = {
                fecha_inicio: this.formGroup.data.dateStartDI,
                fecha_fin: this.formGroup.data.dateEndDI,
                tipo_reporte: this.formGroup.data.filterDI,
                despacho: this.formGroup.data.filterDespacho
            }

            await ReportService.reportDirections(REQUEST).then(
                (responseData) => {
                    if (!responseData.error) {
                        const URL_FILE = responseData.response
                        window.open(`${URL_FILE}`, '_blank')
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoadingReport = false
        },
        reportTelephones: async function () {
            this.isLoadingReport = true;            

            const REQUEST = {
                fechaInicio: this.formGroup.data.dateStartRT,
                fechaFin: this.formGroup.data.dateEndRT,
                despacho: this.formGroup.data.filterDespacho
            }
            await ReportService.reportTelephones(REQUEST).then(
                (responseData) => {
                    if (!responseData.error) {
                        const URL_FILE = responseData.response
                        window.open(`${URL_FILE}`, '_blank')
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoadingReport = false
        },
        getDispatchByMultiAdmin: async function(){
            this.arrFilterDespachos = [];
            try {
                const idUser = await EncryptService.encrypt(localStorage.getItem('ID'));
                const response = await ReportService.getDespachosByUser(idUser);
                if (response.error) {
                    throw new Error(response.msg || 'No se pudieron cargar los despachos.');
                }
                const dispatches = Array.isArray(response.response) ? response.response : [];
                const items = [];
                for (const element of dispatches) {
                    items.push({
                        id_db: await EncryptService.encrypt(element.nombre_bd),
                        id_normal: element.id_despacho,
                        nombre: element.nombre_bd
                    });
                }
                this.arrFilterDespachos = items;
                if (!items.length) {
                    this.snackbarData.description = response.msg || 'No tiene despachos asignados. Contacte al administrador.';
                    this.snackbarData.openSnackbar = true;
                }
            } catch (error) {
                this.snackbarData.description = error.message || 'No se pudieron cargar los despachos. Intente de nuevo.';
                this.snackbarData.openSnackbar = true;
            }
        },
        getUsersByDespachoMA: async function(nombreDb){
            
            this.arrUsers = [];            
            this.formGroup.data.filterUserPA = null;
            this.formGroup.data.filterUserCL = null;
            this.formGroup.data.filterUserGE = null;            
            
            await ReportService.getUserbyDispatchByMA(nombreDb).then(
                async (responseData) => {
                    if (!responseData.error) {
                        let tempArrUser = []
                        for (const element of responseData.response) {
                            tempArrUser.push({
                                ID: await EncryptService.encrypt(element.id.toString()),
                                ID_NORMAL: element.id,
                                NAME_COMPLETE: `${element.name} ${element.last_name} (${element.username})`
                            })
                        }
                        this.arrUsers = tempArrUser
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            );
        },  
        getClienteDespachos: async function(){
            this.arrFilterDespachoClientes = [];
            this.formGroup.data.filterDespachoClienteBA = null;
            this.formGroup.data.dateReportBA = null;
            
            if(this.formGroup.data.typeReport === 'BA'){                            
                await ReportService.getInterntUsersByDispatch(this.formGroup.data.filterDespacho).then(
                    async (responseData) =>{
                        if(!responseData.error){
                            let tempArrBA = [];
                            for(const element of responseData.response){
                                tempArrBA.push({
                                    id: await EncryptService.encrypt(element.despacho),
                                    nombre: element.despacho
                                });
                            }

                            this.arrFilterDespachoClientes = tempArrBA;
                        }else {
                            this.snackbarData.description = responseData.msg
                            this.snackbarData.openSnackbar = true
                        } 
                    }
                )

            }
        },

    },
  }
</script>

<style scoped>
    .container_data {
        width: 100%;
        margin-top: 16px;
        overflow: auto;
        margin-bottom: 30px;
    }
    .container_form {
        max-width: 60%;
        min-width: 900px;
        margin: 0 auto;
    }
    .item_calendar {
        widows: 100%;
        display: flex;
        justify-content: center;
    }


    .img_alert {
        height: 230px;
        width: auto;
        padding: 40px;
    }

    .description-text {
        display: flex;
        justify-content: center;
    }

    .description-text p {
        width: 90%;
        text-align: center;
    }
    

    .container_img {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 16px;
    }
    .container_img img {
        max-height: 200px;
    }

    .content_main_report {
        width: 100%; 
        height: calc(100% - 49px); 
        overflow: auto;
    }
</style>

